import {server} from '../Data/BuildEnvironment'
import {buildUrl} from '../Data/Http'
import {HttpRequest} from '../Data/HttpRequest'

export function list(): HttpRequest {
    return {
        verb: 'GET',
        url: buildUrl(`${server}/customers`, {}),
        headers: {
            'Accept': 'application/json',
        },
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/CustomerResource.ts